'use strict';

module.exports = html;

function html(node) {
  return node.value;
}